﻿const rgHex = /^#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i;
const rgRGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:\/\s*([0-9.]+)\s*)\)^/i;
const rgRGBA = /^rgba\((\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(?:\/\s*([0-9.]+)\s*)\)^/i;

/** 
 * @typedef {Object} RGBColor 
 * @property {number} r
 * @property {number} g
 * @property {number} b
 * @property {number?} a 
 */

/** 
 * @typedef {Object} HSLColor 
 * @property {number} h
 * @property {number} s
 * @property {number} l
 * @property {number?} a 
 */

/**
 * 
 * @param {string?} color
 * @returns {RGBColor}
 */
function parseColor(color) {
	let m;
	if ((m = rgHex.exec(color)))
		return { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16), a: 1 };
	if ((m = rgRGBA.exec(color)))
		return { r: +m[1], g: +m[2], b: +m[3], a: +m[4] };
	if ((m = rgRGB.exec(color)))
		return { r: +m[1], g: +m[2], b: +m[3], a: m[4] != null ? +m[4] : 1 };
}

/**
 * @param {RGBColor|HSLColor} color
 * @returns {number}
 */
function luminocity(color) {
	return color ? color.l !== undefined ? color.l / 100 : (0.299 * color.r + 0.587 * color.g + 0.114 * color.b) / 255 : undefined;
}

/**
 * @param {RGBColor|HSLColor} color
 * @param {number} boundary
 * @returns {"light"|"dark"}
 */
function lightOrDark(color, boundary = 0.5) {
	return color ? luminocity(color) < boundary ? "dark" : "light" : undefined;
}

/**
 * 
 * @param {RGBColor} rgbColor
 * @returns {HSLColor}
 * @see: https://www.rapidtables.com/convert/color/rgb-to-hsl.html
 */
function rgbToHsl(rgbColor) {
	if (!rgbColor)
		return rgbColor;
	const r = rgbColor.r / 255;
	const g = rgbColor.g / 255;
	const b = rgbColor.b / 255;
	const a = rgbColor.a;
	const cmax = Math.max(r, g, b);
	const cmin = Math.min(r, g, b);
	const d = cmax - cmin;

	let h = d == 0 ? 0 :
			cmax == r ? ((g - b) / d) % 6 :
			cmax == g ? ((b - r) / d) + 2 :
			cmax == b ? ((r - g) / d) + 4 :
			0;

	if (h < 0) h += 6;

	const l = (cmax + cmin) / 2;
	const s = l == 1 ? 0 : d / (1 - Math.abs(2 * l - 1));

	return {
		h: Math.round(60 * h),
		s: Math.round(100 * s),
		l: Math.round(100 * l),
		a
	};
}

export { parseColor, luminocity, lightOrDark, rgbToHsl };